import React, { FC } from 'react';
import { NoVideosLayout } from './no-videos-layout';

export const DeletedVideo: FC = function () {
  return <NoVideosLayout titleKey="widget.notification.video-deleted" />;
};
